import { Vue } from '@Ravnur-Inc/vue-class-component';
import { Inject } from '@Ravnur-Inc/decorators';
import matomoConfig from '@/config/matomo';

const DISPLAY_NAME_DIMENSION_INDEX = 1;

export default class MatomoAnalytics extends Vue {
  @Inject('current-user') private user: User$Details;

  private unregisterRouterHook: Nullable<() => void> = null;

  // window._paq is created by vue-matomo before this component renders and queues
  // every call until matomo.js has loaded, so there is nothing to wait for
  mounted() {
    this.init();
  }

  beforeUnmount() {
    if (this.unregisterRouterHook) {
      this.unregisterRouterHook();
      this.unregisterRouterHook = null;
    }
  }

  init() {
    this.pushRouteAnalytics();
    this.unregisterRouterHook = this.$router.afterEach(this.pushRouteAnalytics);
  }

  pushRouteAnalytics() {
    const _paq = (window as any)._paq || [];

    const userId = this.user?.email || this.user?.userName;
    if (userId) {
      _paq.push(
        ['setUserId', userId],
        [
          'setCustomDimension',
          DISPLAY_NAME_DIMENSION_INDEX,
          this.user.displayName || this.user.userName,
        ]
      );
    }

    _paq.push(
      ['setCustomUrl', window.location.origin + this.$router.resolve(this.$route.fullPath).href],
      ['setDocumentTitle', this.$route.name],
      ['trackPageView']
    );

    // links rendered by the new route are only tracked once this is called again
    if (matomoConfig.enableLinkTracking) {
      _paq.push(['enableLinkTracking']);
    }
  }
}
